export default {"src":"/_next/static/media/Arrow.4362c868.svg","height":20,"width":35,"blurWidth":0,"blurHeight":0};